import { render, staticRenderFns } from "./content3d.vue?vue&type=template&id=6b7f6355&scoped=true"
import script from "./content3d.vue?vue&type=script&lang=js"
export * from "./content3d.vue?vue&type=script&lang=js"
import style0 from "./content3d.vue?vue&type=style&index=0&id=6b7f6355&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7f6355",
  null
  
)

export default component.exports